import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _isNil from "lodash/isNil";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.find.js";
import SampleTech from 'const/enums/SampleTech';

// The kinds of data a sample can contain. A sample can contain more than one, e.g. TCR + WT
var Modality = {
  WT: 'wt',
  TCR: 'tcr',
  BCR: 'bcr'
};
var immuneModalities = [Modality.TCR, Modality.BCR];

// Every sample technology needs an entry, Parse or not. A missing one throws
// instead of being treated as WT, so new technologies can't slip through unnoticed
var modalitiesBySampleTech = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, SampleTech.PARSE_WT, [Modality.WT]), SampleTech.PARSE_TCR, [Modality.TCR]), SampleTech.PARSE_BCR, [Modality.BCR]), SampleTech.PARSE_TCR_WT, [Modality.TCR, Modality.WT]), SampleTech.PARSE_BCR_WT, [Modality.BCR, Modality.WT]), SampleTech['10X'], [Modality.WT]), SampleTech.H5, [Modality.WT]), SampleTech.RHAPSODY, [Modality.WT]), SampleTech.SEURAT, [Modality.WT]), SampleTech.ANNDATA, [Modality.WT]);
var getModalities = function getModalities(sampleTech) {
  var modalities = modalitiesBySampleTech[sampleTech];
  if (_isNil(modalities)) {
    throw new Error("No modalities defined for sample technology: ".concat(sampleTech));
  }
  return modalities;
};
var hasImmune = function hasImmune(modalities) {
  return immuneModalities.some(function (modality) {
    return modalities.includes(modality);
  });
};
var hasOnlyImmune = function hasOnlyImmune(modalities) {
  return modalities.length > 0 && modalities.every(function (modality) {
    return immuneModalities.includes(modality);
  });
};

// The immune modality present (tcr or bcr), or undefined if there is none
var findImmuneModality = function findImmuneModality(modalities) {
  return modalities.find(function (modality) {
    return immuneModalities.includes(modality);
  });
};
export default Modality;
export { modalitiesBySampleTech, getModalities, hasImmune, hasOnlyImmune, findImmuneModality };